/* eslint-disable */
import saveStoreDraft from "../../utils/saveStoreDraft";
import useStoreFormDraft from "../../hooks/useStoreFormDraft";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Sidebar from "../../components/sidebar/Sidebar2";
import Navbar from "../../components/navbar/Navbar2";
import Footer from "../../components/footer/Footer";
import { doc, updateDoc, arrayRemove } from "firebase/firestore";
import { db } from "../../firebase";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import DataTableTemplatingIp from "../../components/orders/DataTableTemplatingDemo/DataTableTemplatingIp";
import apicache from "../../components/clearCach/clear";
import {
  FileDigit,
  Save,
  Trash2,
  AlertTriangle,
  Timer,
  Settings,
} from "lucide-react";
import { useTranslation } from "react-i18next";

function OrderSettings() {
  const store = useSelector((state) => state.StoreReducer);
  const account = useSelector((state) => state.AccountReducer);
  const products = useSelector((state) => state.ProductsReducer);
  const ip = useSelector((state) => state.StoreReducer.Adressipblock);
  const MySwal = withReactContent(Swal);
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const [showSideBar, setShowSideBar] = useState(true);
  const [data, setData] = useStoreFormDraft(store);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("tab1");
  const [ipList, setIpList] = useState([]);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {

    if (store.Adressipblock) {
      setIpList(store.Adressipblock);
    }
  }, [store]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    apicache(account, products);

    try {
      await saveStoreDraft(doc(db, "store", data.id), store, data);
      Swal.fire({
        icon: "success",
        title: t("OrderSettings.alerts.save_success.title"),
        confirmButtonText: t("OrderSettings.alerts.save_success.confirm"),
        confirmButtonColor: "#9b59bf",
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: t("OrderSettings.alerts.save_error.title"),
        text: t("OrderSettings.alerts.save_error.text"),
        confirmButtonText: t("OrderSettings.alerts.save_error.confirm"),
        confirmButtonColor: "#9b59bf",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteIP = async (ipToDelete) => {
    try {
      const ipDocRef = doc(db, "store", store.id);

      await updateDoc(ipDocRef, {
        Adressipblock: arrayRemove(ipToDelete),
      });

      const updatedIpList = ipList.filter((ip) => ip !== ipToDelete);
      setIpList(updatedIpList);

      Swal.fire({
        icon: "success",
        title: t("OrderSettings.alerts.ip_delete_success.title"),
        confirmButtonText: t("OrderSettings.alerts.ip_delete_success.confirm"),
        confirmButtonColor: "#9b59bf",
      });
    } catch (error) {
      console.error("Error deleting IP address:", error);
      Swal.fire({
        icon: "error",
        title: t("OrderSettings.alerts.ip_delete_error.title"),
        text: t("OrderSettings.alerts.ip_delete_error.text"),
        confirmButtonText: t("OrderSettings.alerts.ip_delete_error.confirm"),
        confirmButtonColor: "#9b59bf",
      });
    }
  };

  const message = (e) => {
    e.preventDefault();
    MySwal.fire({
      title: (
        <a href="https://m.me/F0orweb" target="_blank">
          {t("footerSettings.swal_contact_link")}
        </a>
      ),
      isDismissed: true,
      confirmButtonColor: "#9b59bf",
    });
  };

  return (
    <div
      className="container-fluid bg-purple-50 min-h-screen dark:!bg-[#141414]"
      dir={isRTL ? 'rtl' : 'ltr'}

    >
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
              boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div className="px-3 dark:!bg-[#141414]" style={{ flex: 1, backgroundColor: "#fbf8fc" }}>
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />

          {/* Page Header */}
          <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 m-3 mt-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <h2 className="text-xl font-bold text-[#9e68ba] mb-1">
                  {t("OrderSettings.page_title")}
                </h2>
                <p className="text-gray-600 dark:!text-gray-300 mb-0">
                  {t("OrderSettings.page_subtitle")}
                </p>
              </div>
              {activeTab === "tab1" && (
                <button
                  onClick={!!account.store ? handleSubmit : message}
                  className={`flex items-center gap-2 bg-[#9b59bf] hover:bg-[#814a9f] text-white py-2 px-4 rounded-lg transition-colors ${loading ? "opacity-75 cursor-wait" : ""
                    }`}
                  disabled={loading}
                >
                  <Save size={18} />
                  <span className="mr-1">
                    {loading
                      ? t("OrderSettings.tab1.saving")
                      : t("OrderSettings.tab1.save_button")}
                  </span>
                </button>
              )}
            </div>
          </div>

          {/* Navigation Tabs */}
          <div className="mx-3 mb-3 flex items-center justify-between bg-white dark:!bg-[#181819] rounded-xl shadow-sm border border-[#fbf4ff] dark:!border-[#3c3a3d] overflow-hidden">
            <div className="flex">
              <button
                className={`px-6 py-3 text-sm font-medium transition-colors ${activeTab === "tab1"
                  ? "bg-[#fcf6ff] dark:!bg-[#3c3a3d] text-[#9e68ba] border-b-2 border-[#bc7ade]"
                  : "text-gray-600 dark:!text-gray-300 hover:bg-[#fcf6ff] dark:hover:!bg-[#2a2a2a]"
                  }`}
                onClick={() => setActiveTab("tab1")}
              >
                <div className="flex items-center gap-2">
                  <Settings size={16} />
                  <span> {t("OrderSettings.tabs.tab1")}</span>
                </div>
              </button>

              <button
                className={`px-6 py-3 text-sm font-medium transition-colors ${activeTab === "tab2"
                  ? "bg-[#fcf6ff] dark:!bg-[#3c3a3d] text-[#9e68ba] border-b-2 border-[#bc7ade]"
                  : "text-gray-600 dark:!text-gray-300 hover:bg-[#fcf6ff] dark:hover:!bg-[#2a2a2a]"
                  }`}
                onClick={() => setActiveTab("tab2")}
              >
                <div className="flex items-center gap-2">
                  <Trash2 size={16} />
                  <span> {t("OrderSettings.tabs.tab2")}</span>
                </div>
              </button>

              <button
                className={`px-6 py-3 text-sm font-medium transition-colors ${activeTab === "tab3"
                  ? "bg-[#fcf6ff] dark:!bg-[#3c3a3d] text-[#9e68ba] border-b-2 border-[#bc7ade]"
                  : "text-gray-600 dark:!text-gray-300 hover:bg-[#fcf6ff] dark:hover:!bg-[#2a2a2a]"
                  }`}
                onClick={() => setActiveTab("tab3")}
              >
                <div className="flex items-center gap-2">
                  <Timer size={16} />
                  <span> {t("OrderSettings.tabs.tab3")}</span>
                </div>
              </button>

              <button
                className={`px-6 py-3 text-sm font-medium transition-colors ${activeTab === "tab4"
                  ? "bg-[#fcf6ff] dark:!bg-[#3c3a3d] text-[#9e68ba] border-b-2 border-[#bc7ade]"
                  : "text-gray-600 dark:!text-gray-300 hover:bg-[#fcf6ff] dark:hover:!bg-[#2a2a2a]"
                  }`}
                onClick={() => setActiveTab("tab4")}
              >
                <div className="flex items-center gap-2">
                  <AlertTriangle size={16} />
                  <span>{t("OrderSettings.tabs.tab4")}</span>
                </div>
              </button>
            </div>
          </div>

          {/* Main Content */}
          <div className="mx-3 mb-6 dark:!bg-[#181819]">
            {/* Order Settings Tab */}
            {activeTab === "tab1" && data && (
              <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                <div className="flex items-center mb-6">
                  <Settings size={20} className="text-[#9e68ba] ml-2" />
                  <h3 className="text-lg font-semibold text-gray-800 dark:!text-gray-200">
                    {t("OrderSettings.tab1.title")}
                  </h3>
                </div>

                <form onSubmit={!!account.store ? handleSubmit : message}>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 dark:!text-gray-300 mb-2">
                        {t("OrderSettings.tab1.max_orders_label")}
                      </label>
                      <div className="relative">
                        <input
                          type="number"
                          min={1}
                          placeholder={t("OrderSettings.tab1.max_orders_placeholder")}
                          value={data.reqNumber}
                          onChange={(e) =>
                            setData({ ...data, reqNumber: e.target.value })
                          }
                          className="w-full px-3 py-2 pr-10 border border-gray-300 dark:!bg-[#181819] dark:!border-[#3c3a3d] rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:focus:ring-[#9e68ba] bg-white dark:bg-[#2a2a2a] text-gray-800 dark:text-gray-200"
                        />
                      </div>
                      <p className="mt-1 text-xs text-gray-500 dark:!text-gray-400">
                        {t("OrderSettings.tab1.max_orders_hint")}
                      </p>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 dark:!text-gray-300 mb-2">
                        {t("OrderSettings.tab1.retry_time_label")}
                      </label>
                      <div className="relative">
                        <input
                          type="number"
                          min={1}
                          placeholder={t("OrderSettings.tab1.retry_time_placeholder")}
                          value={data.reqTime}
                          onChange={(e) =>
                            setData({ ...data, reqTime: e.target.value })
                          }
                          className="w-full px-3 py-2 pr-10 border border-gray-300 dark:!bg-[#181819] dark:!border-[#3c3a3d] rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:focus:ring-[#9e68ba] bg-white dark:bg-[#2a2a2a] text-gray-800 dark:text-gray-200"
                        />
                      </div>
                      <p className="mt-1 text-xs text-gray-500 dark:!text-gray-400">
                        {t("OrderSettings.tab1.retry_time_hint")}
                      </p>
                    </div>
                  </div>
                </form>
              </div>
            )}

            {/* Deleted Orders Tab */}
            {activeTab === "tab2" && (
              <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                <div className="flex items-center mb-6">
                  <Trash2 size={20} className="text-[#9e68ba] ml-2" />
                  <h3 className="text-lg font-semibold text-gray-800 dark:!text-gray-200">
                    {t("OrderSettings.tab2.title")}
                  </h3>
                </div>
                <DataTableTemplatingIp ipList={ip} onDeleteIP={handleDeleteIP} />
              </div>
            )}

            {/* Deleted Auto Orders Tab */}
            {activeTab === "tab3" && (
              <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                <div className="flex items-center mb-6">
                  <Timer size={20} className="text-[#9e68ba] ml-2" />
                  <h3 className="text-lg font-semibold text-gray-800 dark:!text-gray-200">
                    {t("OrderSettings.tab3.title")}
                  </h3>
                </div>
                <div className="text-center py-12">
                  <Timer size={48} className="text-gray-300 mx-auto mb-4 dark:!text-gray-500" />
                  <h4 className="text-lg font-medium text-gray-500 dark:!text-gray-300 mb-2">
                    {t("OrderSettings.tab3.empty_title")}
                  </h4>
                  <p className="text-sm text-gray-400 dark:!text-gray-500">
                    {t("OrderSettings.tab3.empty_description")}
                  </p>
                </div>
              </div>
            )}

            {/* Suspicious Orders Tab */}
            {activeTab === "tab4" && (
              <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                <div className="flex items-center mb-6">
                  <AlertTriangle size={20} className="text-[#9e68ba] ml-2" />
                  <h3 className="text-lg font-semibold text-gray-800 dark:!text-gray-200">
                    {t("OrderSettings.tab4.title")}
                  </h3>
                </div>
                <div className="text-center py-12">
                  <AlertTriangle
                    size={48}
                    className="text-gray-300 mx-auto mb-4 dark:!text-gray-500"
                  />
                  <h4 className="text-lg font-medium text-gray-500 dark:!text-gray-300 mb-2">
                    {t("OrderSettings.tab4.empty_title")}
                  </h4>
                  <p className="text-sm text-gray-400 dark:!text-gray-500">
                    {t("OrderSettings.tab4.empty_description")}
                  </p>
                </div>
              </div>
            )}
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default OrderSettings;
